import classNames from 'classnames'
import { FC } from 'react'

import styles from './grid.module.css'
import { GridItemProps } from './grid.type'


const GridItem: FC<GridItemProps> = ({ children, sm = 4, md = 4, lg = 8, xl = 8, xxl = 8, className }) =>
    <div className={ classNames(
        styles[`sm_${ sm }`],
        styles[`md_${ md }`],
        styles[`lg_${ lg }`],
        styles[`xl_${ xl }`],
        styles[`xxl_${xxl}`],
        className,
    ) }
    >
        { children }
    </div>

export default GridItem
